import React from "react";
import Modal from "react-bootstrap/Modal";


export const ModalChiTiet = (props) => {
  const { show, onHide, item } = props;
  if (!item) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-dialog modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i class="fa-solid fa-circle-info"></i>
          </span>
          Chi tiết loại phiếu
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
        </button>
      </Modal.Header>
      
      <form>
        <Modal.Body className="">
          <div className="form form-horizontal">
            <div className="form-body">
              <div className="form-body">
                {/* Tên loại phiếu */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Tên loại phiếu</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.Name || '---'}
                  </div>
                </div>

                {/* Loại */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Loại</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.Type === 1 ? "Thu" : "Chi"}
                  </div>
                </div>

                {/* Người tạo */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Người tạo</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.CreatedUser || '---'}
                  </div>
                </div>

                {/* Ngày tạo */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Ngày tạo</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.CreatedTime || '---'}
                  </div>
                </div>

                {/* Người cập nhật */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Người cập nhật</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.UpdatedUser || '---'}
                  </div>
                </div>

                {/* Ngày cập nhật */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Ngày cập nhật</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.UpdatedTime || '---'}
                  </div>
                </div>

                {/* Trạng thái */}
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold">Trạng thái</label>
                  <div className="col-md-9" style={{ textAlign: "left" }}>
                    {item.Status === 2 ? "Đã khóa" : "Hoạt động"}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide} // Sử dụng onHide để đóng modal
          >
            <span>
              <i className="mdi mdi-close"></i>
            </span>
            &nbsp; Đóng
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};